import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { SearchSelectComponent } from '../search-select.component';
import { UserSelect, UserSelectMode } from '@app/services/modal.model';

@Component({
    selector: 'app-dai-search-select',
    templateUrl: '../search-select.component.html',
    styleUrls: ['../search-select.component.scss'],
})
export class DaiSearchSelectComponent extends SearchSelectComponent implements OnChanges {

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['selectedId']) {
            if (this.selectedId.length > 0 && this.userList) {
                this.setListControlValue(this.userList.filter(dai => this.selectedId.some(daicd => daicd === dai.daicd)).map(x => x.name));
            } else {
                this.control.setValue([]);
            }
        }
    }

    override onClick(): void {
        let data: UserSelect = {
            mode: UserSelectMode.DAI,
            multiple: this.multiple,
            selectedId: this.selectedId
        };
        const modalDialog = this.dialog.select(data);
        modalDialog.afterClosed().subscribe((result: string[]) => {
            if (result) {
                this.setListControlValue(this.userList?.filter(dai => result.some(daicd => daicd === dai.daicd)).map(x => x.name) || []);
                this.usersChange.emit(result);
            }
        });
    }

}


